import { rtkq, RtkqRequest } from '../rtkq';
import { api } from '../api';
import {
  TermsAndConditionsDto,
  termsAndConditionsHttp,
  UpdateTermsAndConditionsDto,
} from '@/core';

export type TermsAndConditionsState = TermsAndConditionsDto;
export type UpdateTermsAndConditionsArgs = UpdateTermsAndConditionsDto;
export type GetTermsAndConditionsArgs = { organizationId: string };

const termsAndConditionsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTermsAndConditions: build.query<
      TermsAndConditionsState[],
      RtkqRequest<GetTermsAndConditionsArgs>
    >({
      queryFn: async (args) => {
        return await rtkq(args).exec(() =>
          termsAndConditionsHttp.get(args.organizationId),
        );
      },
      providesTags: () => [{ type: 'terms' }],
    }),

    getPendingTermsAndConditions: build.query<
      TermsAndConditionsState | null,
      RtkqRequest<void>
    >({
      queryFn: async () => {
        return await rtkq().exec(() => termsAndConditionsHttp.getPending());
      },
      providesTags: () => [{ type: 'pending-terms' }],
    }),

    getTermsAndConditionsVersion: build.query<
      TermsAndConditionsState,
      RtkqRequest<{ id: string }>
    >({
      queryFn: async (args) => {
        return await rtkq().exec(() =>
          termsAndConditionsHttp.getVersion(args.id),
        );
      },
      providesTags: () => [{ type: 'terms' }],
    }),

    updateTermsAndConditions: build.mutation<
      void,
      RtkqRequest<UpdateTermsAndConditionsArgs>
    >({
      queryFn: (args) => {
        return rtkq(args).exec(() => termsAndConditionsHttp.update(args));
      },
      invalidatesTags: () => [{ type: 'terms' }, { type: 'terms' }],
    }),
  }),
});

export const {
  useGetTermsAndConditionsQuery,
  useGetPendingTermsAndConditionsQuery,
  useUpdateTermsAndConditionsMutation,
  useGetTermsAndConditionsVersionQuery,
} = termsAndConditionsApi;
